import { Link } from 'react-router-dom';

import * as styles from './styles';
import { useQueryClient } from '@tanstack/react-query';

import { Location } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import Icon from '@cobliteam/ui/icons';

import Button from '@cobliteam/ui/components/Button';

import UpdateVersion from '../../UpdateVersion';

enum ExternalLink {
  SUPPORT = 'https://suporte.cobli.co',
  CONTACT = 'https://suporte.cobli.co/pt-BR/articles/4169503-veja-aqui-os-nossos-contatos',
}

export interface SidebarFooterProps {
  logout: () => void;
  open: boolean;
}

export const SidebarFooter = ({ logout, open }: SidebarFooterProps) => {
  const queryClient = useQueryClient();

  const handleClick = (item: Location | string) => () => {
    Analytics.track('Sidebar Item Clicked', { page: item });
  };

  const handleLogout = () => {
    handleClick(Location.LOGOUT)();
    queryClient.clear();
    logout();
  };

  const renderExternalLink = (href: ExternalLink, title: string, Icon: JSX.Element) => (
    <a href={href} onClick={handleClick(href)} className={styles.link} target='_blank' rel='noopener noreferrer'>
      <Button size='condensed' variant='ghost' className='text-white hover:text-gray' startIcon={Icon}>
        {title}
      </Button>
    </a>
  );

  return (
    <>
      <div className={styles.actions}>
        <Link to={Location.LOGIN} className={styles.link} onClick={handleLogout}>
          <Button size='condensed' variant='ghost' className='text-white hover:text-gray' startIcon={<Icon name='log-out' />}>
            Sair
          </Button>
        </Link>
        {open ? (
          <>
            {renderExternalLink(ExternalLink.SUPPORT, 'FAQ', <Icon name='circle-help' />)}
            {renderExternalLink(ExternalLink.CONTACT, 'Contato', <Icon name='headset' />)}
          </>
        ) : null}
      </div>
      <UpdateVersion sidebarOpen={open} />
    </>
  );
};
